export default function getExportingJobs(): string {
  return `/exporting/jobs`;
}
